import React, { useCallback, useState,useEffect } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Modal,Form,Dropdown, Menu, Button,message } from 'antd';
import CreateRecordFlowDrawer from './CreateRecordFlowDrawer';
import GetRecordsFlowDrawer from './GetRecordsFlowDrawer';
import UpdateRecordFlowDrawer from './UpdateRecordFlowDrawer';
import DeleteRecordFlowDrawer from './DeleteRecordFlowDrawer';
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import DecisionRecordFlowDrawer from './DecisionRecordFlowDrawer';
import LoopRecordFlowDrawer from './LoopRecordFlowDrawer';
import FlowSaveModal from './FlowSaveModal';
import EmailFlowDrawer from './EmailFlowDrawer';
// import { Draggable } from '@hello-pangea/dnd';
const getNodeStyle = (nodeType) => {
  switch (nodeType) {
    case 'Create Records':
      return { background: '#EFF3EA', color: 'black',height: '100px',width:'140px' }; // Light blue for Create Records
    case 'Update Records':
      return { background: '#EFF3EA', color: 'black',height: '100px',width:'140px' }; // Light orange for Update Records
    case 'Delete Records':
      return { background: '#FFAD60', color: 'black',height: '100px',width:'140px' }; // Light red for Delete Records
    case 'Get Records':
      return { background: '#EFF3EA', color: 'black',height: '100px',width:'140px' }; // Light blue for Get Records
    case 'Decision':
      return { background: '#FFF2C2', color: 'black', height: '140px', width: '140px', clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)' }; // Diamond shape
    case 'Loop':
        return { background: '#FFF2C2', color: 'black', height: '100px', width: '140px' }; // Diamond shape
    case 'Start':
      return { background: '#D9DFC6', color: 'black', height: '100px', width: '140px' }; // Diamond shape
    case 'Email':
      return { background: '#EFF3EA', color: 'black', height: '100px', width: '140px' }; // Diamond shape
    // case 'End':
    //   return { background: '#FBF8EF', color: 'black', height: '60px', width: '100px' }; // Diamond shape
    default:
      return { background: '#E0E0E0', color: 'black',height: '100px',width:'140px' }; // Default color (gray)
  }
};

const initialNodes = [
  {
    id: 'start',
    position: { x: 210, y: 0 },
    draggable: false,
    data: {
      label: (
        <div style={{ padding: '1px', borderRadius: '5px' }}>
          {/* Include the logo using the relative path from public folder */}
          <img
            src={`${process.env.PUBLIC_URL}/Start_Icon.png`}
            alt="Logo"
            style={{ width: '30px', height: '30px', marginRight: '5px' }}
          />
          <div>
            <h2 style={{marginTop:"12px"}}>Start Node</h2>
          </div>
        </div>
      ),
      nodeName: 'Start',
      
    },
    description: 'This is Start node',
    name:'start',
    apiName:'start',
    type: 'input',
    style: getNodeStyle('Start'), // Corrected here
  },
  // {
  //   id: 'end',
  //   position: { x: 230, y: 450 },
  //   Draggable:false,
  //   data: { label: 'End', description: 'This is End Node', nodeName: 'End' },
  //   type: 'output',
  //   style: getNodeStyle('End'), // Corrected here
  // },
];
// const initialEdges = [{ id: 'e1-2', source: 'start', target: 'end' }];


const FlowUI = ({setSelectedFlowData,selectedFlowData,object,setIsCreatingFlow,setIsEditingFlow,isEditingFlow,fetchFlows}) => {

  const [nodes, setNodes, onNodesChange] = useNodesState(!isEditingFlow? initialNodes : []);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [createRecordDrawerVisible, setCreateRecordDrawerVisible] = useState(false);
  const [newNodeId, setNewNodeId] = useState(3);
  const [getRecordsDrawerVisible, setGetRecordsDrawerVisible] = useState(false);
  const [updateRecordsDrawerVisible, setUpdateRecordsDrawerVisible] = useState(false);
  const [deleteRecordDrawerVisible, setDeleteRecordDrawerVisible] = useState(false);
  const [getRecordsData, setGetRecordsData] = useState({}); // Store Get Records data here
  const [updateRecordData, setUpdateRecordData] = useState({}); // Store Get Records data here
  const [deleteRecordData, setDeleteRecordData] = useState({}); // Store Get Records data here
  const [createRecordData, setCreateRecordData] = useState({}); // Store Get Records data here
  const [decisionRecordData, setDecisionRecordData] = useState({});
  const [decisionDrawerVisible, setDecisionDrawerVisible] = useState(false); // Store Get Records data here
  const [decisionConnectedNodes, setDecisionConnectedNodes] = useState([]);
  const [loopDrawerVisible,setLoopDrawerVisible] = useState(false);
  const [emailDrawerVisible,setEmailDrawerVisible] = useState(false);
  const [loopRecordData, setLoopRecordData] = useState({});
  const [emailRecordData, setEmailRecordData] = useState({});
  const [highlightedNode, setHighlightedNode] = useState(null);
  // const [highlightedNodeId, setHighlightedNodeId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);  
  const [singleCreateRecordDataInEditMode,setSingleCreateRecordDataInEditMode] = useState([]);
  const [singleUpdateRecordDataInEditMode,setSingleUpdateRecordDataInEditMode] = useState([]);
  const [singleGetRecordDataInEditMode,setSingleGetRecordDataInEditMode] = useState([]);
  const [singleEmailRecordDataInEditMode,setSingleEmailRecordDataInEditMode] = useState([]);
  const [singleDeleteRecordDataInEditMode,setSingleDeleteRecordDataInEditMode] = useState([]);
  const [singleDecisionRecordDataInEditMode,setSingleDecisionRecordDataInEditMode] = useState([]);
  const [singleLoopRecordDataInEditMode,setSingleLoopRecordDataInEditMode] = useState([]);

  useEffect(() => {
    if (isEditingFlow && selectedFlowData) {
     
      const { nodes: newNodes, edges: newEdges } = processFlowData(selectedFlowData);

      // Update state for nodes and edges
      setNodes((prevNodes) => [...prevNodes, ...newNodes]); // Append new nodes
      setEdges((prevEdges) => [...prevEdges, ...newEdges]); // Append new edges
      
    }
  }, [isEditingFlow,selectedFlowData]);

  const showModal = () => {
    setIsModalVisible(true);
  };
  
  const processFlowData = (flowData) => {
    if (!flowData || !flowData.mt_nodes || !flowData.mt_transitions) {
      return { nodes: [], edges: [] };
    }
  
  
    // Categorize nodes by type for state storage
    const createRecordsData = {};
    const getRecordsData = {};
    const updateRecordsData = {};
    const deleteRecordsData = {};
    const decisionRecordsData = {};
  
    const nodes = flowData.mt_nodes.map((node) => {
      const { _id, name, coordinates, type } = node;
      const nodeType = getNodeType(type);
      const { imgSrc, label, imgStyle } = getNodeContent(nodeType);
      const style = getNodeStyle(nodeType);
      // Store nodes based on type for later state update
      // node.type =nodeType;
      switch (nodeType) {
        case "Create Records":
          createRecordsData[_id] = node;
          break;
        case "Get Records":
          getRecordsData[_id] = node;
          break;
        case "Update Records":
          updateRecordsData[_id] = node;
          break;
        case "Delete Records":
          deleteRecordsData[_id] = node;
          break;
        case "Decision":
          decisionRecordsData[_id] = node;
          break;
        
        default:
          break;
      }
      return {
        ...node, // Spread node directly to keep all properties
        id: _id,
        position: { x: coordinates?.[0] || 200, y: coordinates?.[1] || 150 },
        draggable: true,
        data: { label: (
          <div style={{  borderRadius: '5px' }}>
            <img
              src={imgSrc}  // Use dynamic image source based on node type
              alt="Node Icon"
              style={{
                ...imgStyle, // Apply dynamic dimensions
                marginRight: '10px', // Consistent spacing
              }}
            />
            <div>
              <h2 style={{margin:"0px"}}>{label}</h2>  {/* Dynamic label based on node type */}
              {/* <p>{description}</p>  Dynamic description based on node type */}
            </div>
          </div>
          ),
        nodeName: type
        },
        // data: {
        //   label: (
        //     <div>
        //       <img src={imgSrc} alt="Node Icon" style={{ ...imgStyle, marginRight: "10px" }} />
        //       <h3 style={style}>{label}</h3>
        //     </div>
        //   ),
        //   nodeName: name,
        // },
        style,
        type:nodeType
      };
    });
  
    // Update all state setters in one batch
    setCreateRecordData((prev) => ({ ...prev, ...createRecordsData }));
    setGetRecordsData((prev) => ({ ...prev, ...getRecordsData }));
    setUpdateRecordData((prev) => ({ ...prev, ...updateRecordsData }));
    setDeleteRecordData((prev) => ({ ...prev, ...deleteRecordsData }));
    setDecisionRecordData((prev) => ({ ...prev, ...decisionRecordsData }));
  
    // Add the static Start Node
    nodes.unshift({
      id: "start",
      position: { x: 210, y: 0 },
      draggable: false,
      data: {
        label: (
          <div style={{ padding: "1px", borderRadius: "5px" }}>
            <img src={`${process.env.PUBLIC_URL}/Start_Icon.png`} alt="Logo" style={{ width: "30px", height: "30px", marginRight: "5px" }} />
            <h2 style={{marginTop:"12px"}}>Start Node</h2>
          </div>
        ),
        nodeName: "Start",
      },
      type: "input",
      style: getNodeStyle("Start"),
    });
  
    // Map mt_transitions to edges
    const edges = flowData.mt_transitions
      .map((transition) => {
        const { _id, from_node, to_node } = transition;
  
        const fromNodeId = from_node === "Node 1" ? "start" : flowData.mt_nodes.find((n) => n.name === from_node)?._id;
        const toNodeId = flowData.mt_nodes.find((n) => n.name === to_node)?._id;
  
        if (!fromNodeId || !toNodeId) {
          console.error(`Invalid transition: from_node=${from_node}, to_node=${to_node}`);
          return null;
        }
  
        return {
          id: _id,
          source: fromNodeId,
          target: toNodeId,
          animated: false,
          label: "Edge Label Here",
        };
      })
      .filter(Boolean);
  
    return { nodes, edges };
  };
  
  

const getAllNodesData = (getRecordsData, updateRecordData, deleteRecordData, createRecordData) => {
  return {
    ...getRecordsData,
    ...updateRecordData,
    ...deleteRecordData,
    ...createRecordData,
  };
};


const CustomNode = ({ data }) => {
  return (
    <div style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
      {/* Include the logo using the relative path from public folder */}
      <img 
        src={data.icon}  // Use the icon from the node data
        alt={`${data.label} Icon`}
        style={{ width: '40px', height: '30px', margin:'2px' }}
      />
      <div>
        <h2 style={{margin:"0px"}}>{data.label}</h2>
      </div>
      {/* <p>{data.description}</p> */}
    </div>
  );
};

const edgeStyles = {
  stroke: 'black',
  strokeWidth: 1,
};

const nodeTypes = {
  customNode: CustomNode,
};

const getNodeContent = (type) => {
  // Define the dynamic content based on node type
  switch (type) {
    case 'Delete Records':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Delete_Icon.png`,
        label: 'Delete Node',
        imgStyle: { width: '40px', height: '40px',paddingbottom: '1px'}, 
        // description: 'delete action node.',
      };
    case 'Decision':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Decision_Icon.png`,
        label: 'Decision Node',
        imgStyle: { width: '25px', height: '25px',marginLeft:'9px',marginTop:'6px' }, 
        // description: 'decision point.',
      };
    case 'Get Records':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Get_Icon.png`,
        label: 'Get Node',
        imgStyle: { width: '40px', height: '40px',marginTop:'8px' }, 
        // description: 'data retrieval.',
      };
    case 'Update Records':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Update_Icon.png`,
        label: 'Update Node',
        imgStyle: { width: '40px', height: '40px',marginTop:'8px' }, 
        // description: 'update action.',
      };
    case 'Create Records':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Create_Icon.png`,
        label: 'Create Node',
        imgStyle: { width: '40px', height: '40px',marginTop:'8px' }, 
        // description: 'create action.',
      };
    case 'Loop':
        return {
          imgSrc: `${process.env.PUBLIC_URL}/Loop_Icon.png`,
          label: 'Loop',
          imgStyle: { width: '40px', height: '40px',marginTop:'8px' }, 
          // description: 'create action.',
        };
    case 'Email':
      return {
        imgSrc: `${process.env.PUBLIC_URL}/Email_Icon.png`,
        label: 'Email',
        imgStyle: { width: '40px', height: '40px',marginTop:'10px',marginLeft:'7px' }, 
        // description: 'create action.',
      };
    default:
      return {
        imgSrc: `${process.env.PUBLIC_URL}/default_Icon.png`,
        label: 'Default Node',
        description: 'This is a default node.',
      };
  }
};

const getNodeType = (type)=>{
  switch(type){
    case 'Create Records':
      return 'insert';
    case 'Update Records':
      return 'update';
    case 'Delete Records':
      return 'delete';
    case 'Decision':
      return 'decision';
    case 'Get Records':
      return 'get_query';
    case 'insert':
      return 'Create Records';
    case 'update':
      return 'Update Records';
    case 'delete':
      return 'Delete Records';
    case 'decision':
      return 'Decision';
    case 'get_query':
      return 'Get Records';
    default:
      return '';
  }
}

  // Handle node addition
  const addNode = useCallback(
    (type) => {
      const targetNode = highlightedNode || nodes[nodes.length - 1];
      if (!targetNode) {
        return; // Ensure that there is a selected node before adding a new one
      }
      
      const sourceNodeEdges = edges.filter((edge) => edge.source === targetNode.id);
      if (sourceNodeEdges.length > 0) {
        console.log(`Node "${targetNode.type}" already has an output.`);
        message.error(`Node "${targetNode.type}" already has an output.`);
        return; // Prevent adding another edge
      }

      
      if(targetNode.type === 'Decision' && !decisionRecordData?.outcomes?.picklist){
        message.error('please select outcome element');
        return;
      }
      const newNodePosition = {
        x: targetNode.position?.x , // Adjust X to the right of the target node
        y: targetNode.position?.y + 200,  // Adjust Y slightly below the target node
      };
  
      const { imgSrc, label,imgStyle, description } = getNodeContent(type); 
      // const nodeType = getNodeType({ data: { nodeName: type } }); //
      const newNode = {
        id: `node-${newNodeId}`,
        position: newNodePosition,
        draggable:true,
        apiname: '',
        description:'',
        name:'',
    //     data: { 
    //        nodeName: type
    //  },
        data: { label: (
          <div style={{  borderRadius: '5px' }}>
            <img
              src={imgSrc}  // Use dynamic image source based on node type
              alt="Node Icon"
              style={{
                ...imgStyle, // Apply dynamic dimensions
                marginRight: '10px', // Consistent spacing
              }}
            />
            <div>
              <h2 style={{marginTop:"5px"}}>{label}</h2>  {/* Dynamic label based on node type */}
              {/* <p>{description}</p>  Dynamic description based on node type */}
            </div>
          </div>
        ),
      nodeName: type
     },
        type: type, // Set shape as diamond for Decision nodes
        style:getNodeStyle(type)
      };

      // Increment the node ID counter
      setNewNodeId((prev) => prev + 1);

      // Add the new node to the state
      setNodes((nds) => [...nds, newNode]);

      // Create a new edge from the selected node to the newly created node
      setEdges((eds) => [
        ...eds,
        { id: `e-${targetNode.id}-${newNode.id}`, source: targetNode.id, target: newNode.id , label: 'Edge Label Here',   },
      ]);
    },
    [highlightedNode, nodes, setNodes, setEdges,edges, newNodeId, decisionRecordData]
  );

  // Dropdown menu for node actions
  const menu = (
    <Menu
      onClick={(e) => addNode(e.key)}
      items={[
        { 
          key: "Decision", 
          label: "Decision",
          icon: <img src={`${process.env.PUBLIC_URL}/Decision_Icon.png`} alt="Decision" width={20} />
        },
        { 
          key: "Create Records", 
          label: "Create Records",
          icon: <img src={`${process.env.PUBLIC_URL}/Create_Icon.png`} alt="Create Records" width={20} />
        },
        { 
          key: "Update Records", 
          label: "Update Records",
          icon: <img src={`${process.env.PUBLIC_URL}/Update_Icon.png`} alt="Update Records" width={20} />
        },
        { 
          key: "Get Records", 
          label: "Get Records",
          icon: <img src={`${process.env.PUBLIC_URL}/Get_Icon.png`} alt="Get Records" width={20} />
        },
        { 
          key: "Delete Records", 
          label: "Delete Records",
          icon: <img src={`${process.env.PUBLIC_URL}/Delete_Icon.png`} alt="Delete Records" width={20} />
        },
        { 
          key: "Loop", 
          label: "Loop",
          icon: <img src={`${process.env.PUBLIC_URL}/Loop_Icon.png`} alt="Loop" width={20} />
        },
        { 
          key: "Email", 
          label: "Email",
          icon: <img src={`${process.env.PUBLIC_URL}/Email_Icon.png`} alt="Email" width={20} />
        },
      ]}
    />
  );  

  // Handle node double-click to open the drawer
  const onNodeDoubleClick = (_, node) => {
    const updatedNodes = nodes.map((eachNode) =>
      eachNode.id === node.id ? { ...eachNode, draggable: false } : eachNode
    );
    setNodes(updatedNodes);
  
    if (node?.type === 'Create Records') {

        setSingleCreateRecordDataInEditMode(createRecordData?.[node.id] || []); 
        setSelectedNode(node); // Set the selected node
        setCreateRecordDrawerVisible(true); // Open the drawer
      } else if (node?.type === 'Get Records') {
        setSingleGetRecordDataInEditMode(getRecordsData?.[node.id] || []); 
        setSelectedNode(node);
        setGetRecordsDrawerVisible(true);
      } else if (node?.type === 'Update Records') {
        setSingleUpdateRecordDataInEditMode(updateRecordData?.[node.id] || []); 
        setSelectedNode(node);
        setUpdateRecordsDrawerVisible(true);
      } else if (node?.type === 'Delete Records') {
        setSingleDeleteRecordDataInEditMode(deleteRecordData?.[node.id] || []);
        setSelectedNode(node);
        setDeleteRecordDrawerVisible(true);
      }else if (node?.type === 'Decision') {
        setSingleDecisionRecordDataInEditMode(decisionRecordData?.[node.id] || []);
        const outgoingEdges = edges.filter((edge) => edge.source === node.id);
    
        // Fetch connected node names
        const connectedNodes = outgoingEdges.map((edge) => {
          const targetNode = nodes.find((n) => n.id === edge.target);
          return targetNode?.type || `Node ${edge.target}`;
        });
    
        setSelectedNode(node);
        setDecisionDrawerVisible(true);
        setDecisionConnectedNodes(connectedNodes); // Pass connected nodes to the drawer
      } else if(node?.type === 'Loop'){
        setSingleLoopRecordDataInEditMode(loopRecordData?.[node.id] || []);
        setLoopDrawerVisible(true);
        setSelectedNode(node);
      }else if(node?.type === 'Email'){
        setSingleEmailRecordDataInEditMode(emailRecordData?.[node.id] || [])
        setEmailDrawerVisible(true);
      }
      else {
      }

  };

  const handleBackspace = (event) => {

    if (event.code === 'Backspace' && highlightedNode) {
      if(highlightedNode.id === 'start'){
        message.error('Cannot Delete the Start Node');
        return;
      }
      const isConnectedToDecision = edges.some((edge) => {
        const sourceNode = nodes.find((node) => node.id === edge.source);
        return edge.target === highlightedNode.id && sourceNode?.type === 'Decision';
    });
    
    if (isConnectedToDecision) {
        message.error('Please delete the outcome connections for this node before deleting it.');
        return;
    }
    if(highlightedNode.type === 'Decision' || highlightedNode.type === 'decision'){
      clearNodesAndEdgesForDecision(highlightedNode);
    }
    
      // Delete the selected node from the nodes state
      setNodes((prevNodes) => prevNodes.filter((node) => node.id !== highlightedNode.id));
  
      // Remove the edges associated with the selected node
      setEdges((prevEdges) => prevEdges.filter((edge) => edge.source !== highlightedNode.id && edge.target !== highlightedNode.id));
  
      // Remove the associated data for the deleted node (in all the data states)
      setGetRecordsData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setUpdateRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setDeleteRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setCreateRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      setDecisionRecordData((prevData) => {
        const { [highlightedNode.id]: _, ...remainingData } = prevData;
        return remainingData;
      });

      // Clear the highlighted node after deletion
      setHighlightedNode(null);
    }
  };
  
  const isApiNameUnique = (apiName, nodeId, allNodesData) => {
    for (const [id, data] of Object.entries(allNodesData)) {
      if (id !== nodeId && data.apiName === apiName) {
        return false; // API name is already taken by another node
      }
    }
    return true; // API name is unique
  };
  
  const handleEmailRecordsSave = (nodeId, getData) => {
  }

  const handleGetRecordsSave = (nodeId, getData) => {
    const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

  if (!isApiNameUnique(getData.apiName, nodeId, allNodesData)) {
    alert(`API name "${getData.apiName}" is already taken. Please choose a different name.`);
    return;
  }
  const parameters = getNodeParameters(getData, false);

  setNodes((prevNodes) =>
    prevNodes.map((node) =>
      node.id === nodeId
        ? {
            ...node,
            data: {
              ...node.data,
              nodeName: getData.apiName, // Set the API name for the node
            },
            description:getData.description,
            apiname:getData.apiName,
            name:getData.name,
            parameters, 
            // style:getNodeStyle(getData.type)
          }
        : node
    )
  );
    const getNode = {
      id: nodeId,
      name: getData.name,
      type: getData.type,
      description: getData.description,
      apiname: getData.apiName,
      parameters,  
    };


    setGetRecordsData((prevData) => ({
      ...prevData,
      [nodeId]: getNode, // Store or update data for the given nodeId
    }));
  };
  
  // Handler for saving Update Records data
  const handleUpdateRecordSave = (nodeId, updateData) => {
    const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

  if (!isApiNameUnique(updateData.apiName, nodeId, allNodesData)) {
    alert(`API name "${updateData.apiName}" is already taken. Please choose a different name.`);
    return;
  }
  const parameters = getNodeParameters(updateData);
  setNodes((prevNodes) =>
    prevNodes.map((node) =>
      node.id === nodeId
        ? {
            ...node,
            data: {
              ...node.data,
              nodeName: updateData.apiName, // Set the API name for the node
            },
            description:updateData.description,
            apiname:updateData.apiName,
            name:updateData.name,
            parameters,
            // style:getNodeStyle(updateData.type)
          }
        : node
    )
  );
  const updateNode = {
    id: nodeId,
    name: updateData.name,
    type: updateData.type,
    description: updateData.description,
    apiname: updateData.apiName,
    parameters,  
  };


    setUpdateRecordData((prevData) => ({
      ...prevData,
      [nodeId]: updateNode, // Store or update data for the given nodeId
    }));
  };
  
  // Handler for saving Delete Records data
  const handleDeleteRecordSave = (nodeId, deleteData) => {
    const jsonObject = typeof deleteData === 'string' ? JSON.parse(deleteData) : deleteData;
    const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

  if (!isApiNameUnique(jsonObject.apiName, nodeId, allNodesData)) {
    alert(`API name "${jsonObject.apiName}" is already taken. Please choose a different name.`);
    return;
  }
  const parameters = getNodeParameters(jsonObject);
  setNodes((prevNodes) =>
    prevNodes.map((node) =>
      node.id === nodeId
        ? {
            ...node,
            data: {
              ...node.data,
              nodeName: jsonObject.apiName, // Set the API name for the node
              
            },
            description:jsonObject.description,
            apiname:jsonObject.apiName,
            name:jsonObject.name,
            parameters
          }
        : node
    )
  );
  const deleteNode = {
    id: nodeId,
    name: jsonObject.name,
    type: jsonObject.type,
    description: jsonObject.description,
    apiname: jsonObject.apiName,
    parameters,  
  };


    setDeleteRecordData((prevData) => ({
      ...prevData,
      [nodeId]: deleteNode, // Store or update data for the given nodeId
    }));
    console.log(`Delete Records Data for node ${nodeId}:`, deleteNode);
  };
  
  // Handler for saving Create Records data
  const handleCreateRecordSave = (nodeId, createData) => {
    const allNodesData = getAllNodesData(getRecordsData, updateRecordData, deleteRecordData, createRecordData);

  if (!isApiNameUnique(createData.apiName, nodeId, allNodesData)) {
    alert(`API name "${createData.apiName}" is already taken. Please choose a different name.`);
    return;
  }
  const parameters = getNodeParameters(createData,false); // Generate
  setNodes((prevNodes) =>
    prevNodes.map((node) =>
      node.id === nodeId
        ? {
            ...node,
            data: {
              ...node.data,
              nodeName: createData.apiName, // Set the API name for the node
            },
           selectedObject:createData.selectedObject ,
           parameters,
           description:createData.description,
           apiname:createData.apiName,
           name:createData.name
          }
        : node
    )
  );
  // setCreateRecordData((prevData) => ({
  //   ...prevData,
  //   [nodeId]: createNode, // Store or update data for the given nodeId
  // }));
  
  
  const createNode = {
    id:createData.id,
    name: createData.name, // Assign unique names to nodes
    type: createData.type,
    description:createData.description,
    apiname:createData.apiName,
    parameters: parameters,
    // coordinates: [node.position.x, node.position.y]
  };

  setCreateRecordData((prevData) => ({
    ...prevData,
    [nodeId]: createNode, // Store or update data for the given nodeId
  }));
    console.log(`Create Records Data for node ${nodeId}:`, createData);
  };
  
  const handleLoopRecordSave = (loopData) => {
    if (!selectedNode) {
      return;
    }
  
    clearNodesAndEdgesForLoop(selectedNode);
  
    createNodesForLoopElements(loopData);
  };
  
  const clearNodesAndEdgesForLoop = (loopNode) => {
    if (!loopNode) return;
    let connectedNodeIds;
    setEdges((prevEdges) => {
      // Filter out edges connected to the loop node
      const edgesToRemove = prevEdges.filter((edge) => edge.source === loopNode.id);
      connectedNodeIds = edgesToRemove.map((edge) => edge.target);
  
      // Keep only edges not connected to the loop node
      return prevEdges.filter((edge) => edge.source !== loopNode.id);
    });
  
    setNodes((prevNodes) => {
      // Remove nodes connected to the loop node
      return prevNodes.filter(
        (node) =>
          node.id === loopNode.id || // Keep the loop node
          !connectedNodeIds?.includes(node.id) // Exclude connected nodes
      );
    });
  };
  
  const createNodesForLoopElements = (loopData) => {
    if (!selectedNode) {
      return;
    }
  
    if (!newNodeId) {
      return;
    }
  
    const newNodes = [];
    const newEdges = [];
  
    // Create node for 'For Each'
    const forEachNodeId = `node-${newNodeId}`;
    const { imgSrc: forEachImgSrc, label: forEachLabel, imgStyle: forEachImgStyle } = getNodeContent(loopData.forEach);
    const forEachNode = {
      id: forEachNodeId,
      position: { x: Math.random() * 500 + 100, y: Math.random() * 200 + 100 },
      data: {
        label: (
          <div>
            <img
              src={forEachImgSrc}
              alt="Node Icon"
              style={{ ...forEachImgStyle, marginRight: '10px' }}
            />
            <h2 style={{ margin: '0px' }}>{forEachLabel}</h2>
          </div>
        ),
        nodeName: loopData.forEach,
      },
      type: 'default',
      style: getNodeStyle(loopData.forEach),
    };
  
    newNodes.push(forEachNode);
  
    // Create edge from Loop to For Each
    newEdges.push({
      id: `e-${selectedNode.id}-${forEachNodeId}`,
      source: selectedNode.id,
      target: forEachNodeId,
      label: 'For Each',
    });
  
    // Create edge from For Each back to Loop
    newEdges.push({
      id: `e-${forEachNodeId}-${selectedNode.id}`,
      source: forEachNodeId,
      target: selectedNode.id,
      label: 'For Each Loop Back',
    });
  
    // Create node for 'After Last'
    const afterLastNodeId = `node-${newNodeId + 1}`;
    const { imgSrc: afterLastImgSrc, label: afterLastLabel, imgStyle: afterLastImgStyle } = getNodeContent(loopData.afterLast);
    const afterLastNode = {
      id: afterLastNodeId,
      position: { x: Math.random() * 500 + 100, y: Math.random() * 200 + 300 },
      data: {
        label: (
          <div>
            <img
              src={afterLastImgSrc}
              alt="Node Icon"
              style={{ ...afterLastImgStyle, marginRight: '10px' }}
            />
            <h2 style={{ margin: '0px' }}>{afterLastLabel}</h2>
          </div>
        ),
        nodeName: loopData.afterLast,
      },
      type: 'default',
      style: getNodeStyle(loopData.afterLast),
    };
  
    newNodes.push(afterLastNode);
  
    // Create edge from Loop to After Last
    newEdges.push({
      id: `e-${selectedNode.id}-${afterLastNodeId}`,
      source: selectedNode.id,
      target: afterLastNodeId,
      label: 'After Last',
    });
  
    // Update state with new nodes and edges
    setNodes((prevNodes) => [...prevNodes, ...newNodes]);
    setEdges((prevEdges) => [...prevEdges, ...newEdges]);
  
    // Increment the node ID counter
    setNewNodeId((prev) => prev + 2); // Increment for both nodes created
  };
  
  const handleDecisionRecordSave = (nodeId, decisionData) => {
    if (!nodeId) {
      console.error("No decision node selected for connecting outcomes.");
      return;
    }
    const parameters = getNodeParameters(decisionData);
    setNodes((prevNodes) =>
      prevNodes.map((node) =>
        node.id === nodeId
          ? {
              ...node,
              data: {
                ...node.data,
                nodeName: decisionData.name, // Set the API name for the node
              },
              apiname: decisionData.apiName,
              description:decisionData.description,
              name:decisionData.name,
              parameters
            }
          : node
      )
    );
    const decisionNode = {
      id:nodeId,
      name: decisionData.name, // Assign unique names to nodes
      type: decisionData.type,
      description:decisionData.description,
      apiname:decisionData.apiName,
      parameters: parameters,
      // coordinates: [node.position.x, node.position.y]
    };
  
    clearNodesAndEdgesForDecision(decisionNode);
  
    
    // Save decision data using nodeId as the key
    setDecisionRecordData((prevData) => ({
      ...prevData,
      [nodeId]: decisionNode, // Update or add data for the specific decision node
    }));
  
    createNodesForDecisionOutcomes(decisionData);
  };  

  const clearNodesAndEdgesForDecision = (decisionNode) => {
    if (!decisionNode) return;
    let connectedNodeIds;
    setEdges((prevEdges) => {
      // Filter out edges connected to the decision node
      const edgesToRemove = prevEdges.filter((edge) => edge.source === decisionNode.id);
      connectedNodeIds = edgesToRemove.map((edge) => edge.target);
  
      // Keep only edges not connected to the decision node
      return prevEdges.filter((edge) => edge.source !== decisionNode.id);
    });
  
    setNodes((prevNodes) => {
      // Remove nodes that were connected to the decision node via edgesToRemove
      return prevNodes.filter(
        (node) =>
          node.id === decisionNode.id || // Keep the decision node
          !connectedNodeIds?.includes(node.id) // Exclude nodes connected via edges
      );
    });
  };
  const createNodesForDecisionOutcomes = (decisionData) => {
  if (!selectedNode) {
    console.error("No decision node selected for connecting outcomes.");
    return;
  }

  if (!newNodeId) {
    console.error("newNodeId is not defined.");
    return;
  }

  const newNodes = [];
  const newEdges = [];
  const targetNode = highlightedNode || nodes[nodes.length - 1];
  const decisionX = targetNode.position?.x;
  const decisionY = targetNode.position?.y;
  const spacing = 150; // Horizontal spacing between nodes
  const verticalOffset = 200; // Vertical offset below the decision node
  const outcomeCount = decisionData.outcomes.length;
  const startX = decisionX - (outcomeCount - 1) * spacing / 2;


  decisionData.outcomes.forEach((outcome, index) => {
    // Generate a unique ID for the new node
    const nodeId = `node-${newNodeId + index}`;
    const { imgSrc, label, imgStyle } = getNodeContent(outcome.picklist);

    const newNodePosition = {
      x: startX + index * spacing, // Distribute nodes horizontally
      y: decisionY + verticalOffset, // Position all nodes below the decision node
    };

    // Create the new node
    const newNode = {
      id: nodeId,
      position: newNodePosition,
      draggable:true,
      data: { 
        label: (
          <div>
            <img
              src={imgSrc}
              alt="Node Icon"
              style={{ ...imgStyle, marginRight: '10px' }}
            />
            <h2 style={{ margin: '0px' }}>{label}</h2>
          </div>
        ),
        nodeName: outcome.picklist,
      },
      type: outcome.picklist,
      style: getNodeStyle(outcome.picklist),
    };

    // Add the node to the temporary array
    newNodes.push(newNode);

    // Create the edge connecting the selected node (decision node) to the new node
    const newEdge = {
      id: `e-${selectedNode.id}-${nodeId}`,
      source: selectedNode.id, // The source node is a Decision
      target: nodeId, // The target node type is based on the picklist
      label: outcome.label, // Custom label based on the node type
    };

    // Add the edge to the temporary array
    newEdges.push(newEdge);
  });

  // Update the global state with all new nodes and edges at once
  setNodes((prevNodes) => [...prevNodes, ...newNodes]);
  setEdges((prevEdges) => [...prevEdges, ...newEdges]);

  // Increment the node ID counter
  setNewNodeId((prev) => prev + decisionData.outcomes.length); // Adjust based on new nodes
};


    const handleCancel = () => {
        // Reset or close all drawers
        setCreateRecordDrawerVisible(false);
        setGetRecordsDrawerVisible(false);
        setUpdateRecordsDrawerVisible(false);
        setDeleteRecordDrawerVisible(false);
        setDecisionDrawerVisible(false);
        setLoopDrawerVisible(false);
        setIsCreatingFlow(false);
        setIsModalVisible(false);
        setIsEditingFlow(false);
    };
    
  const handleSave = async () => {
    setIsModalVisible(true);

  };


  const generateFlowBody = (flowName, apiName, event, description) => {
    const modelName = object.object.name || ""; // Model coming as prop, default to "Paperr"
    // Transform nodes into the required structure
    const transformedNodes = nodes
      .filter((node) => node.id !== "start" 
      // && node.id !== "end"
    ) // Exclude start and end nodes
      .map((node, index) => {
        const nodeType = getNodeType(node.type); // Determine the node type (decision, insert, update, etc.)
        const parameters =  node.parameters ; // Generate parameters for each node
        return {
          name: node.data.nodeName, // Assign unique names to nodes
          type: nodeType,
          description:node.description,
          apiname:node.apiname,
          parameters: parameters,
          coordinates: [node.position?.x, node.position?.y]
        };
      });
  
    // Transform edges into the required structure
    const transformedTransitions = edges.map((edge) => {
      const fromNode = nodes.find((node) => node.id === edge.source);
      const toNode = nodes.find((node) => node.id === edge.target);
    
      const fromNodeName =
        edge.source === "start"
          ? "Node 1" // Map start node to "Node 1"
          : fromNode?.data.nodeName || edge.source;
  
      const toNodeName =
        edge.target === "end"
          ? "Node 2" // Map end node to "Node 2"
          : toNode?.data.nodeName || edge.target;
    
      let condition = "true"; // Default condition if not a Decision node
    
      if (fromNode?.type === "Decision") {
        const decisionData = decisionRecordData[fromNode.id];
    
        if (decisionData && decisionData.outcomes) {
          // Find the correct outcome for this specific transition
          const matchedOutcome = decisionData.outcomes.find(
            (outcome) =>
              outcome.picklist === toNode?.type && 
              outcome.apiName !== undefined // Ensure we get the correct API name
          );
    
          // Assign the correct API name for the transition condition
          condition = matchedOutcome ? matchedOutcome.apiName : "false";
        }
      }
    
      return {
        from_node: fromNodeName || edge.source,
        to_node: toNodeName || edge.target,
        condition: condition, // Use the correct outcome's API name as condition
      };
    });
  
    // Construct the final payload
    const body = {
    //   mt_flow: {
        name: apiName,
        model: modelName,
        event: event,
        description: description,
        mt_nodes: transformedNodes,
        mt_transitions: transformedTransitions,
    //   },
    };
  
    return body;
  };

  const setttingFilters=(filters)=>{
  const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.value
        }; 
      }
      return acc;
    }, {});

    return filterObj;
  }

  // Helper function to generate parameters for each node
  const getNodeParameters = (node,fromFlowBody) => {
    switch (node.type) {
      case "Decision":
        return {
          model: node?.selectedObject || '',
          conditions: node?.outcomes?.map((outcome, index) => ({
            logic_string: outcome.logic_string || "1",
            name: outcome.label, // Use outcome API name for transition
            apiname: outcome.apiName,
            picklist:outcome.picklist,
          //   conditions: outcome.filters?.reduce((acc, filter, filterIndex) => {
          //     let operator = Object.keys(filter.value || {})[0]; // Extract operator
          //     let actualValue = operator ? filter.value[operator] : filter.value;
      
          //     acc[filterIndex + 1] = {  // Ensure unique numeric keys for conditions
          //       field: filter.field || "",
          //       value: operator ? { [operator]: actualValue } : actualValue
          //     };
          //     return acc;
          //   }, {}) || {}  // Default to empty object if no filters
          // })) || []

          conditions:setttingFilters(outcome.filters),
         })) || []
        };
  
        case "Create Records":
          if(fromFlowBody){
            return {
                model: node?.parameters?.model || "", // Use model if available
                fields: Object.entries(node?.parameters?.fields || {}).reduce((acc, [key, value]) => {
                  acc[key] = value; // Convert object into the expected format
                  return acc;
                }, {}) // Ensure a valid fallback
            }
          }
          return {
            model: node?.selectedObject || "", // Use selected object
            fields: node?.fields?.reduce((acc, fieldObj) => {
              acc[fieldObj.field] = fieldObj.value; // Convert array to object
              return acc;
            }, {}) || {} // Ensure a valid fallback
          };
      case "Update Records":
        return {
            model: node?.selectedObject || "",  // Default to "DefaultModel" if no selectedObject is provided
            logic_string: node?.logic || "1",  // Default to "1" if no logic is provided

            // Transform the filterObj to conditions object, assuming filterObj follows the format you provided
            conditions: Object.keys(node?.filterObj || {}).reduce((acc, key) => {
              const condition = node?.filterObj[key];
              acc[key] = {
                field: condition.field,
                value: condition.value, // Adjust as needed for condition values
              };
              return acc;
            }, {}),

            // Ensure fieldValues are structured as an object for updates
            updates: node?.fieldValues || {},
        };
      case "Delete Records":
        if(fromFlowBody){
          return {
            model: node?.parameters?.model || "",  // Default to empty string
            logic_string: node?.parameters?.logic_string || "1",   // Default to "1"
            
            // Convert `conditions` array into expected `filterObj` format
            conditions: node?.parameters?.conditions?.length > 0
        ? node?.parameters?.conditions.reduce((acc, condition, index) => {
            acc[index + 1] = {
                field: condition.field || "",
                value: condition.value || "",
            };
            return acc;
        }, {})
        : node?.parameters?.filterObj || {},
        };
        }
        return {
            model: node?.selectedObject || "",  // Default to empty string
            logic_string: node?.logic || "1",   // Default to "1"
            
            // Convert filterObj object to an array of condition objects
            conditions: node?.filterObj || {}
        };
          case "Get Records":
            if(fromFlowBody){
              return {
                model: node?.parameters?.model || "",  // Default to empty string
                logic_string: node?.parameters?.logic_string || "1",   // Default to "1"
                
                // Convert `conditions` array into expected `filterObj` format
                conditions: node?.parameters?.conditions?.length > 0
            ? node?.parameters?.conditions.reduce((acc, condition, index) => {
                acc[index + 1] = {
                    field: condition.field || "",
                    value: condition.value || "",
                };
                return acc;
            }, {})
            : node?.parameters?.filterObj || {},
            };
            }
            return {
                model: node?.selectedObject || "",  // Default to empty string
                logic_string: node?.logic || "1",   // Default to "1"
                
                // Convert filterObj object to an array of condition objects
                conditions: Object.values(node?.filterObj || {}).map(filter => {
                  const operator = Object.keys(filter.value || {})[0]; // Extract operator (e.g., "contains")
                  const actualValue = filter.value[operator] || "";  // Extract actual value (e.g., "asds")
              
                  return {
                      field: filter.field || "",
                      value: {[operator]:actualValue || ""}
                  };
              }),              
            };
      
      case "Loop":
        return {
          model: "Sticker", // Example model
          fields: { Name: "$Name" }, // Example field
        };
      default:
        return {};
    }
  };
  const handleNodeClick = (event, node) => {
    const updatedNodes = nodes.map((eachNode) =>
      eachNode.id === node.id ? { ...eachNode, draggable: true } : eachNode
    );
    setNodes(updatedNodes);  
    setNodes((nds) =>
      nds.map((n) => {
        if (n.id === node.id) {
          // Highlight the newly selected node
          return { 
            ...n, 
            style: { ...n.style, border: '3px dashed black' } 
          };
        }
        if (n.id === highlightedNode?.id) {
          // Revert the previously highlighted node to its original style
          return { 
            ...n, 
            style: getNodeStyle(n.id === 'start'? 'Start': n.type) 
          };
        }
        return n; // Leave other nodes unchanged
      })
    );
    setHighlightedNode(node); // Update the current highlighted node ID
  };

  

  return (
    <div style={{ width: '90vw', height: '90vh' }}>
      {/* React Flow */}
      <ReactFlow
        onNodeClick={handleNodeClick}
        // nodeStyles={(nodeId) => {
        //   if (nodeId === highlightedNodeId) {
        //     return { fill: 'orange', stroke: 'red' }; // Highlighting style for the selected node
        //   }
        //   return { fill: 'lightblue', stroke: 'gray' }; // Default style
        // }}

        nodes={nodes}
        edges={edges?.map(edge => ({ ...edge, style: edgeStyles }))}
        nodeTypes={nodeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={(params) => {
          const sourceNode = nodes.find((node) => node.id === params.source);
          const targetNode = nodes.find((node) => node.id === params.target);
          if(sourceNode.type === 'Decision' && !decisionRecordData?.outcomes?.picklist){
            message.error('please select outcome element');
            return;
          }
          if (!sourceNode || !targetNode) {
            return;
          }
          const sourceNodeEdges = edges.filter((edge) => edge.source === params.source);
          if (sourceNode.type !== 'Decision' && sourceNodeEdges.length >= 2) {
            message.error('Selected Node Cannot have more than two connections.');
            return;
          }
          // Allow only "Decision" nodes to have multiple outputs
          if (sourceNode.type !== 'Decision'  && sourceNodeEdges.length > 1) {
            message.error(`Node "${sourceNode.type}" can only have one output.`);
            return;
          }
          const newEdge = {
            ...params,
            id: `e-${params.source}-${params.target}`,
            sourceType: sourceNode.type, // Include source node type
            targetType: targetNode.type, // Include target node type
            label: targetNode.data.nodeName === 'End' ?  '' : 'edge label here'
          };
        
          // Add the edge if the rule is satisfied
          setEdges((eds) => addEdge(newEdge, eds));
        }}
        onNodeDoubleClick={onNodeDoubleClick}
        fitView
        onKeyDown={(e)=> handleBackspace(e)}
        style={{ width: '80vw', height: '80vh' }}  // Adjust width and height here

      >
        <Controls />
        <MiniMap />
        <Background />
        {/* Add "+" button near each node */}
        {nodes.map((node) => {
          if (node.id === 'end') return null; // Skip for the "End" node
          return (
            <Dropdown overlay={menu} trigger={['click']} key={`dropdown-${node.id}`}>
              <div
                style={{
                  position: 'absolute',
                  top: node.position.y + (node.width / 2) - 60, // Position the "+" button 60px below the node
                  left: node.position.x + (node.width / 2) - 15, // Position the "+" button horizontally centered below the node (node.width / 2 - 15 for half the width of the button)
                  zIndex: 10,
                  background: '#fff',
                  border: '1px solid #ccc',
                  width: 100,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                }}
                onClick={() => setSelectedNode(node)}
              >
                Add Node +
              </div>
            </Dropdown>
          );
        })}
      </ReactFlow>

      {/* Drawer for Node Configuration */}
      <CreateRecordFlowDrawer isEditingMode={isEditingFlow} selectedNode={selectedNode} onSave ={handleCreateRecordSave} visible={createRecordDrawerVisible} onClose={() => setCreateRecordDrawerVisible(false)} nodeData={singleCreateRecordDataInEditMode} setNodeData= {setSingleCreateRecordDataInEditMode}/>
      <GetRecordsFlowDrawer
        selectedNode={selectedNode} 
        visible={getRecordsDrawerVisible}
        onClose={() => setGetRecordsDrawerVisible(false)}
        nodeData={singleGetRecordDataInEditMode}
        onSave={handleGetRecordsSave} 
        setNodeData= {setSingleGetRecordDataInEditMode}
        isEditingMode={isEditingFlow}
        />
        <UpdateRecordFlowDrawer
        selectedNode={selectedNode} 
        visible={updateRecordsDrawerVisible}
        onClose={() => setUpdateRecordsDrawerVisible(false)}
        nodeData={singleUpdateRecordDataInEditMode}
        getRecordsData={getRecordsData} // Pass Get Records data to Update Records
        onSave={handleUpdateRecordSave}  
        setNodeData= {setSingleUpdateRecordDataInEditMode}
        isEditingMode={isEditingFlow}
      />
        <DeleteRecordFlowDrawer
        selectedNode={selectedNode} 
        visible={deleteRecordDrawerVisible}
        onClose={() => setDeleteRecordDrawerVisible(false)}
        nodeData={singleDeleteRecordDataInEditMode}
        getRecordsData={getRecordsData} // Pass Get Records data to Update Records
        onSave={handleDeleteRecordSave}
        setNodeData= {setSingleDeleteRecordDataInEditMode}
        isEditingMode={isEditingFlow} 
      />
      <DecisionRecordFlowDrawer 
      selectedNode={selectedNode} 
      visible={decisionDrawerVisible}
      onClose={() => setDecisionDrawerVisible(false)}
      nodeData={singleDecisionRecordDataInEditMode}
      getRecordsData={getRecordsData} // Pass Get Records data to Update Records
      onSave={handleDecisionRecordSave}
      connectedNodes={decisionConnectedNodes} // Pass connected nodes
      setNodeData= {setSingleDecisionRecordDataInEditMode}
      isEditingMode={isEditingFlow}
      />
      <LoopRecordFlowDrawer 
      selectedNode={selectedNode} 
      visible={loopDrawerVisible}
      onClose={() => setLoopDrawerVisible(false)}
      nodeData={singleLoopRecordDataInEditMode}
      getRecordsData={getRecordsData} // Pass Get Records data to Update Records
      onSave={handleLoopRecordSave}
      setNodeData= {setSingleLoopRecordDataInEditMode}
      // connectedNodes={decisionConnectedNodes} // Pass connected nodes
      />
      <EmailFlowDrawer
      onClose={()=> setEmailDrawerVisible(false)}
      visible={emailDrawerVisible}
      nodeData={singleEmailRecordDataInEditMode}
      onSave={handleEmailRecordsSave}
      />
      <div
  style={{
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)', // Centers the buttons horizontally
    display: 'flex', // For aligning the buttons in a row
    gap: '10px', // Adds spacing between the buttons
    background: 'white'
  }}
>
  <Button type="primary" onClick={handleSave}>Save</Button>
  <Button type="default" onClick={handleCancel}>Cancel</Button>
</div>

{isModalVisible && (
      <FlowSaveModal
        generateFlowBody={generateFlowBody}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
        setIsCreatingFlow={setIsCreatingFlow}
        setIsEditingFlow={setIsEditingFlow}
        fetchFlows={fetchFlows}
        setSelectedFlowData={setSelectedFlowData}
      />
    )}
    </div>
  );
};

export default FlowUI;
